import { combineReducers } from '@reduxjs/toolkit';
import { channelApi, graphqlApiWithPersisted, rootApi } from '../services';
import cardDetailsModal from '../slices/CardDetailsModalSlice';
import cardDetails from '../slices/CardDetailsSlice';
import channelNotifications from '../slices/ChannelNotificationsSlice';
import channels from '../slices/ChannelsSlice';
import channelUsers from '../slices/ChannelUsersSlice';
import commentsFeed from '../slices/CommentsFeedSlice';
import eventDetails from '../slices/EventDetailsSlice';
import eventDetailsModal from '../slices/EventDetailsModalSlice';
import eventDiscussionFeed from '../slices/EventDiscussionFeedSlice';
import eventsFeed from '../slices/EventsFeedSlice';
import inAppMessages from '../slices/InAppMessagesSlice';
import latestsStoryCardsFeed from '../slices/LatestsStoryCardsFeedSlice';
import newsFeed from '../slices/NewsFeedSlice';
import organisationUsers from '../slices/OrganisationUsersSlice';
import pushNotifications from '../slices/PushNotificationsSlice';
import searchFeed from '../slices/SearchFeedSlice';
import storiesCardsUserFeed from '../slices/StoriesCardsUserFeedSlice';
import stories from '../slices/StoriesSlice';
import storyCardsBookmarksFeed from '../slices/StoryCardsBookmarksFeedSlice';
import storyCardsUserProfileFeed from '../slices/StoryCardsUserProfileFeedSlice';
import storyFeed from '../slices/StoryFeedSlice';
import tagsFeed from '../slices/TagsFeedSlice';

export const rootReducer = combineReducers({
  [rootApi.reducerPath]: rootApi.reducer,
  [channelApi.reducerPath]: channelApi.reducer,
  [graphqlApiWithPersisted.reducerPath]: graphqlApiWithPersisted.reducer,
  newsFeed,
  searchFeed,
  storyFeed,
  tagsFeed,
  commentsFeed,
  storiesCardsUserFeed,
  eventsFeed,
  storyCardsBookmarksFeed,
  storyCardsUserProfileFeed,
  latestsStoryCardsFeed,
  cardDetailsModal,
  cardDetails,
  eventDetails,
  eventDetailsModal,
  eventDiscussionFeed,
  channelNotifications,
  pushNotifications,
  inAppMessages,
  organisationUsers,
  channelUsers,
  channels,
  stories,
});
